import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-best-prac',
  templateUrl: './best-prac.component.html',
  styleUrls: ['./best-prac.component.scss']
})
export class BestPracComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.location.back();
  }

}

